import { RecentOrFavoriteOrderMeal } from '@/models';
import { AnalyticsEvent } from '../models';

export class AccountManagementEvent implements AnalyticsEvent {
  name = 'AccountManagementEvent';

  constructor(public readonly eventType: string, public readonly meals?: RecentOrFavoriteOrderMeal | RecentOrFavoriteOrderMeal[], public readonly rewardTitle?: string, public readonly siteSection?: string) { }
}
